export const authI18n = {
  en: {
    loginPopup: {
      signIn: 'Sign In',
      signUp: 'Sign Up',
      username: 'Username',
      password: 'Password',
      helpPassword: 'Get help with your password here'
    },
    forgotPasswordPopup:{
      passResetText: 'We are not able to send your password, but we can help you reset it. Please enter your Username or Email and click "Send instructions". We will send you an Email with a link that allows you to change your password. Please note that the link expires after 30 minutes.',
      passResetPlaceholder: 'Username or Email',
      passResetButton: 'Send instructions',
      passResetNotFound:'Username or email not found',
      goBack:'Back to login',
      passResetLinkSent:'Email sent',
      passTitle:'Did you forget your password?'
    },
    validateCode:{
      validateTitle: 'Validate Code',
      verifyCodeText: 'Enter your 6 digit verification code',
      invalidCode: 'The code is invalid',
      timedOut: 'This link has expired, redirecting to home...',
      validateButton: 'Validate',
      maxAttempts: 'The maximum number of attemps has been reached, redirecting to home...',
      alreadyValidated: 'This link has already been validated, redirecting to home...'
    },
    resetPassword:{
      resetTitle: 'Reset Password',
      resetLabel1: 'New password',
      resetLabel2: 'Confirm new password',
      resetPlaceholder: 'Password',
      samePasswordError: 'The new passwords must be the same',
      successReset: 'Password reset successful',
      buttonText: 'Reset password',
      changeTitle: 'Change Password',
      changeLabel1: 'Old password',
      welcomeMsg: 'Welcome ',
      oldPasswordError: 'The password you entered does not match your current password',
      successChange: 'Password changed successfully',
      buttonTextChange: 'Change password',
      genericError: 'The password cannot be changed right now, please try again later',
      oldNewEqualError: 'The old and the new password should be different',
      showPassword: 'Show password',
      hidePassword: 'Hide password'
    },
    userMenu: {
      userRequests: 'User requests',
      logout: 'Logout',
      changePassword: 'Change password',
      bulkCreation: 'Bulk Creation'
    },
    progressBar: {
      weak: 'Weak',
      medium: 'Medium',
      strong: 'Strong',
      minLength: 'Minimun length is 8 characters',
      oneUppercase: 'You need at least one uppercase character',
      oneLowercase: 'You need at least one lowercase character',
      oneNumber: 'You need at least one numeric character',
      specialChar: 'You need at least one special character',
      noSpace: 'Must not contain space'
    },
    register: {
      register: 'Register',
      profile: 'Profile',
      basicInfo: 'Basic Information',
      accountInfo: 'Account Information',
      userAgreement: 'User Agreement',
      student: 'Student',
      teacher: 'Teacher',
      yes: 'Yes',
      no: 'No',
      userVerify: 'User verification',
      termsOfUse: 'Terms of Use',
      selectAll: 'Select All',
      profilePage: {
        contentCreator: 'Content Creator',
        teacherAccount: 'Eduac Teacher Account',
        studentAccount: 'Eduac Student Account',
        teacherParag1: 'Is a powerful interface that let you:',
        teacherParag2: 'Publish eBooks in our store or privately in your organization.',
        teacherParag3: 'Create viewer o publisher accounts inside organizations.',
        teacherParag4: 'Everything the viewer account can do.',
        studentParag1: 'Is an easy-to-use interface that let you:',
        studentParag2: 'Read and annotate interactive eBooks.',
        studentParag3: 'Create and share share interactive eNotebooks.',
        studentParag4: 'Purchase eBooks in our store.'
      },
      agreementPage: {
        agreeParag1: 'User registration agreement.. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
        agreeParag2: 'Some text to enable scrolling.. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
        agreeParag3: 'Some text to enable scrolling.. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.'
      },
      headers: {
        firstName: 'First Name',
        middleName: 'Middle Initial',
        lastName: 'Last Name',
        address: 'Address',
        addressLine2: 'Address line 2',
        addressLine3: 'Address line 3',
        phone: 'Phone Number',
        phoneExt: 'Ext.',
        country: 'Country',
        state: 'State/Province',
        city: 'City',
        zipcode: 'Zip/Postal Code',
        email: 'Email Address',
        password: 'Password',
        retypePassword: 'Re-type Password',
        username: 'Username',
        repInstitution: 'Represent an institution?',
        instName: 'Institution Name',
        instType: 'Institution Type',
        regEnterprice: 'Registered Enterprise',
        ein: 'EIN',
        mainCategory: 'Main Category',
        websiteAddress: 'Website Address',
        sameAddressApplicant: 'Is same address as applicant',
        sameAddressInstitution: 'Is same address as institution',
        instAddress: 'Institution Address',
        instAddressLine2: 'Institution Address line 2',
        instAddressLine3: 'Institution Address line 3',
        code: 'Code'
      },
      completeInvitationPage: {
        acceptInvitationEduac: 'Accept invitation to EDUAC',
        invitationSubtitle1: 'You have been invited to join {orgName} as a {invitationType} at',
        invitationSubtitle2: 'From there you will be able to:',
        invitationItem1: 'Create & publish books',
        invitationItem2: 'Sell books in Eduac store',
        invitationItem3: 'Share your content',
        invitationItem4: 'And more...',
        contactUs1: 'If you have any question, please',
        contactUs2: 'Contact Us',
        contactUs3: 'for support.'
      },
      substituteInvitationPage: {
        acceptInvitationEduac: 'Accept invitation to EDUAC as substitute teacher',
        invitationSubtitle1: 'You have been invited by {invitedByFullName} to join {orgName} as a substitute teacher from {startDate} to {endDate}',
        invitationClasses: 'The classes you will be teaching are',
        invitationClass: 'The class you will be teaching is',
        contactUs1: 'If you have any question, please',
        contactUs2: 'Contact Us',
        contactUs3: 'for support.'
      },
      info: {
        verifyMessage: 'In order to verify your phone number, we can either call you or send you a text message. Please select how would you like to verify your phone number:',
        message: 'Message',
        validatePhoneMessage: 'Please enter the six digits code you just received on phone number: {phone}',
        didntReceiveCode: 'Did not receive your code?',
        sendCodeAgain: 'Send/Call again',
        mustSelectVerifyMethod: 'Must select a verification method',
        zipcodeNotFound: 'The zipcode that you entered could not be found',
        registerConfirmation: 'The registration Request was successfully completed. At this moment our Department of Tech Support will contact you to complete the registration. At the same time, EDUAC will send an email to the registered mail given by the user, informing that the registration is pending for confirmation by EDUAC Tech Support department.',
        acceptInvitationConfirm: 'Are you sure you want to accept the invitation?',
        passInvitationConfirm: 'Are you sure you want to reject the invitation?',
        organizationExists: 'The institution name is already in use. Please change it.',
        attempts: 'Attempts: ',
        validatingPhone: 'Waiting for phone validation...',
      },
      success: {
        phoneVerified: 'The phone number was verified successfully.',
        userVerified: 'Your account has been validated.',
        clickToLogin: 'Click here to go to the login page'
      },
      errors: {
        samePasswordError: 'Password does not match with confirmation',
        registerError: 'There was an error with the registration, please try again.',
        username: 'The username is already in use. Please change it.',
        email: 'The email is already in use. Please change it.',
        phoneNoValid: 'Phone number is not valid',
        codeNotSent: 'We could not send the verification code. Please check your phone number and try again.',
        phoneCodeRateLimited: 'Please wait {seconds} seconds before requesting another verification code.',
        registrationRateLimited: 'Please wait {seconds} seconds before continuing.',
        phoneNoVerified: 'Invalid phone validation code. Please try again.',
        phoneCodeExpired: 'Validation code expired. Please request a new one.',
        phoneCodeMaxAttemptExceeded: 'Validation code max attempt exceeded. Please request a new one.',
        userNoVerified: 'An unexpected error occurred validating the user.',
        invitationNoAccepted: 'There was an error trying to accept the invitation.',
        invitationNoDeclined: 'There was an error trying to decline the invitation.',
        invitationExpired: 'The invitation is expired.',
        requestTypeNotSupported: 'Request type not supported.',
        phoneIsNotVerified: 'Phone number is not verified',
        categoryNotSelected: 'Category not selected',
        termsNotAccepted: 'T&C was not accepted',
        phoneAlreadyExists: 'The phone is already in use.',
      },
      buttons: {
        back: 'Back',
        next: 'Next',
        verify: 'Verify',
        acceptTerms: 'Accept Terms of Use',
        acceptInvitation: 'Accept Invitation',
        passInvitation: 'No, pass this invitation',
        confirm: 'Confirm'
      }
    },
    errors: {
      login: 'Username or password invalid',
      notSuccessful: 'Your login attempt was not successful, try again.',
      badRequest: 'Error in the request'
    }
  },
  es: {
    loginPopup: {
      signIn: 'Ingresar',
      signUp: 'Registrar',
      username: 'Usuario',
      password: 'Contraseña',
      helpPassword: 'Obtén ayuda con tu password aquí'
    },
    forgotPasswordPopup:{
      passResetText: 'No podemos enviar tu contraseña, pero podemos ayudarte a restaurarla. Por favor ingresa tu Usuario o tu Email y haz click en "Enviar instrucciones". Enviaremos un correo con un link que te permitirá cambiar la contraseña. Por favor tener en cuenta que el link expira después de 30 minutos.',
      passResetPlaceholder: 'Email o Usuario',
      passResetButton: 'Enviar instrucciones',
      passResetNotFound:'Usuario o correo inválidos',
      goBack:'Devuelta al login',
      passResetLinkSent:'Email enviado',
      passTitle:'Olvidaste tu contraseña?'
    },
    validateCode:{
      validateTitle:'Validar Código',
      verifyCodeText: 'Ingresa tu código de verificación de 6 dígitos',
      invalidCode:'El código es inválido',
      timedOut:'El link ha expirado, redireccionando a la página principal...',
      validateButton:'Validar',
      maxAttempts: 'Se ha alcanzado el número máximo de intentos, redireccionando a la página principal...',
      alreadyValidated: 'Este link ya ha sido validado, redireccionando a la página principal...'
    },
    resetPassword:{
      resetTitle: 'Restablecer Contraseña',
      resetLabel1: 'Nueva contraseña',
      resetLabel2: 'Confirmar nueva contraseña',
      resetPlaceholder: 'Contraseña',
      samePasswordError: 'Las dos contraseñas nuevas deben coincidir',
      successReset: 'Restablecimiento de contraseña exitoso',
      buttonText: 'Restablecer contraseña',
      changeTitle: 'Cambiar Contraseña',
      changeLabel1: 'Anterior contraseña',
      welcomeMsg: 'Bienvenido ',
      oldPasswordError: 'La contraseña que ingresaste no es la misma que tu contraseña actual',
      successChange: 'Cambio de contraseña exitoso',
      buttonTextChange: 'Cambiar contraseña',
      genericError: 'La contraseña no puede ser cambiada en este momento, intenta mas tarde',
      oldNewEqualError: 'La nueva y la anterior contraseña deben ser diferentes',
      showPassword: 'Mostrar Contraseña',
      hidePassword: 'Ocultar Contraseña'
    },
    userMenu: {
      userRequests: 'Solicitudes de registro',
      logout: 'Salir',
      changePassword: 'Cambiar contraseña',
      bulkCreation: 'Registro masivo'
    },
    progressBar: {
      weak: 'Débil',
      medium: 'Media',
      strong: 'Fuerte',
      minLength: 'La longitud mínima es de 8 carácteres',
      oneUppercase: 'Debe contener al menos una mayúscula',
      oneLowercase: 'Debe contener al menos una minúscula',
      oneNumber: 'Debe contener al menos un número',
      specialChar: 'Debe contener al menos un carácter especial',
      noSpace: 'No puede contener espacios'
    },
    register: {
      register: 'Registro',
      profile: 'Perfil',
      basicInfo: 'Información Básica',
      accountInfo: 'Información de Cuenta',
      userAgreement: 'Acuerdo de Usuario',
      student: 'Estudiante',
      teacher: 'Profesor',
      yes: 'Si',
      no: 'No',
      termsOfUse: 'Términos de Uso',
      userVerify: 'Verificación de usuario',
      selectAll: 'Seleccionar todo',
      profilePage: {
        contentCreator: 'Creador de contenido',
        teacherAccount: 'Cuenta de profesor Eduac',
        studentAccount: 'Cuenta de estudiante Eduac',
        teacherParag1: 'Es una interfaz poderosa que le permitirá:',
        teacherParag2: 'Publicar libros electrónicos en nuestra tienda o de manera privada en su organización.',
        teacherParag3: 'Crear cuentas de viewer o publisher al interior de las organizaciones.',
        teacherParag4: 'Todo lo que una cuenta viewer puede hacer.',
        studentParag1: 'Es una interfaz fácil de usar que le permitirá:',
        studentParag2: 'Leer y tomar nota sobre libros electrónicos.',
        studentParag3: 'Crear y compartir eNotebooks interactivos.',
        studentParag4: 'Comprar libros electrónicos en nuestra tienda.'
      },
      headers: {
        firstName: 'Nombre',
        lastName: 'Apellido',
        middleName: 'Inicial de Segundo Nombre',
        address: 'Dirección',
        addressLine2: 'Dirección linea 2',
        addressLine3: 'Dirección linea 3',
        phone: 'Teléfono',
        phoneExt: 'Extensión',
        country: 'País',
        state: 'Estado/Provincia',
        city: 'Ciudad',
        zipcode: 'Código Postal',
        email: 'Correo Electrónico',
        password: 'Contraseña',
        retypePassword: 'Repita Contraseña',
        username: 'Nombre de Usuario',
        repInstitution: '¿Representa una institución?',
        instName: 'Nombre de la Institución',
        instType: 'Tipo de Institución',
        regEnterprice: 'Empresa Registrada',
        ein: 'EIN',
        mainCategory: 'Categorías Principales',
        websiteAddress: 'Dirección Web',
        sameAddressApplicant: '¿Es la misma dirección del solicitante?',
        sameAddressInstitution: '¿Es la misma dirección de la institución?',
        instAddress: 'Dirección de la Insitución',
        instAddressLine2: 'Dirección de la Insitución linea 2',
        instAddressLine3: 'Dirección de la Insitución linea 3',
        code: 'Código',
      },
      agreementPage: {
        agreeParag1: 'Acuerdo de registro de usuario.. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
        agreeParag2: 'Texto para habilitar scrolling.. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
        agreeParag3: 'Texto para habilitar scrolling.. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.'
      },
      completeInvitationPage: {
        acceptInvitationEduac: 'Aceptar invitación a EDUAC',
        invitationSubtitle1: 'Ha sido invitado a unirse a {orgName} como un {invitationType} en',
        invitationSubtitle2: 'Desde allí podrá:',
        invitationItem1: 'Crear y publicar libros',
        invitationItem2: 'Vender libros en la tienda de EDUAC',
        invitationItem3: 'Compartir su contenido',
        invitationItem4: 'Y más...',
        contactUs1: 'Si tiene alguna pregunta, por favor',
        contactUs2: 'Contáctanos',
        contactUs3: 'para dar soporte.'
      },
      substituteInvitationPage: {
        acceptInvitationEduac: 'Aceptar invitación a EDUAC como profesor substituto',
        invitationSubtitle1: 'Ha sido invitado por {invitedByFullName} para unirse a {orgName} como profesor sustituto entre {startDate} y {endDate}',
        invitationClasses: 'Las clases en las que será sustituto son',
        invitationClass: 'La clase en la que será sustituto es',
        contactUs1: 'Si tiene alguna pregunta, por favor',
        contactUs2: 'Contáctanos',
        contactUs3: 'para dar soporte.'
      },
      info: {
        verifyMessage: 'Para verificar su número telefónico, podemos hacer una llamada o enviar un mensaje de texto. Por favor seleccione como desea verificar su número telefónico:',
        message: 'Mensaje',
        validatePhoneMessage: 'Por favor introduce el código de 6 dígitos que acabas de recibir en el numero telefónico: {phone}',
        didntReceiveCode: 'No recibiste tu código?',
        sendCodeAgain: 'Enviar/Llamar de nuevo',
        mustSelectVerifyMethod: 'Debe seleccionar un método de verificación',
        zipcodeNotFound: 'El código postal que ingresó, no fue encontrado',
        registerConfirmation: 'La solicitud de registro fue completada exitosamente. En estos momentos nuestro departamento de soporte técnico lo contactará para completar el registro. Adicionalmente, EDUAC le enviará un correo electrónico a la dirección registrada, informando que el registro está pendiente por confirmación por parte del departamento de soporte técnico de EDUAC.',
        acceptInvitationConfirm: '¿Seguro que quiere aceptar la invitación?',
        passInvitationConfirm: '¿Seguro que quieres rechazar la invitación?',
        organizationExists: 'El nombre de institución ya está en uso, por favor cámbielo.',
        attempts: 'Número de intentos: ',
        validatingPhone: 'Esperando validación del teléfono...'
      },
      success: {
        phoneVerified: 'El número telefónico fue verificado con éxito.',
        userVerified: 'Su cuenta ha sido validada.',
        clickToLogin: 'Click aquí para ir a la página de login'
      },
      errors: {
        samePasswordError: 'Contraseña y confirmación no coinciden',
        registerError: 'Hubo un error en el registro, por favor intente nuevamente.',
        username: 'El nombre de usuario ya está en uso, por favor cámbielo',
        email: 'El correo ya está en uso, por favor cámbielo',
        phoneNoValid: 'El número telefónico no es válido',
        codeNotSent: 'No se pudo enviar el código de verificación, por favor verifique su número telefónico e intente nuevamente.',
        phoneCodeRateLimited: 'Espera {seconds} segundos antes de solicitar otro código de verificación.',
        registrationRateLimited: 'Espera {seconds} segundos antes de continuar.',
        phoneNoVerified: 'El número telefónico no pudo ser verificado, intente nuevamente.',
        userNoVerified: 'Ocurrió un error inesperado al validar el usuario',
        invitationNoAccepted: 'Hubo un error al aceptar la invitación.',
        invitationNoDeclined: 'Hubo un error al declinar la invitación.',
        invitationExpired: 'La invitación expiró.',
        requestTypeNotSupported: 'Tipo de solicitud no soportada',
        phoneIsNotVerified: 'Número de teléfono no verificado',
        categoryNotSelected: 'Categoria no seleccionada',
        termsNotAccepted: 'Terminos no aceptados'
      },
      buttons: {
        back: 'Anterior',
        next: 'Siguiente',
        verify: 'Verificar',
        acceptTerms: 'Aceptar términos de uso',
        acceptInvitation: 'Aceptar invitación',
        passInvitation: 'No, pasar esta invitación',
        confirm: 'Confirmar'
      }
    },
    errors: {
      login: 'Usuario o contraseña inválidos',
      notSuccessful: 'El ingreso no fue satisfactorio, por favor intente de nuevo',
      badRequest: 'Error en la solicitud'
    }
  }
};
